/* eslint-disable @typescript-eslint/no-explicit-any */
import { useKeycloak } from "@react-keycloak/web";
import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState
} from "react";

interface SubscriptionData {
  subscription: string;
  subscriptionMini: string;
  subscriptionsAvailable: RoleAttributes[];
  setSubscription(subscription: string): void;
}

export interface RoleAttributes {
  name?: string;
  mini?: string;
  subscriptionId?: string;
}

const SubscriptionContext = createContext({});

export const SubscriptionProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [subscription, setSubscription] = useState<string>("");
  const [subscriptionMini, setSubscriptionMini] = useState<string>("");
  const [subscriptionsAvailable, setSubscriptionAvailable] = useState<
    RoleAttributes[]
  >([]);
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized && keycloak?.authenticated) {
      loadSubscriptionsFromUser();
    }
  }, [keycloak?.authenticated, initialized]);

  useEffect(() => {
    if (subscriptionsAvailable.length > 0) {
      let hasSub = false;

      const sub = localStorage.getItem("subscription");

      if (sub)
        hasSub = Boolean(
          subscriptionsAvailable.find((role) => role.subscriptionId === sub)
        );

      setSubscriptionAndStore(
        hasSub ? sub : subscriptionsAvailable[0].subscriptionId
      );
    }
  }, [subscriptionsAvailable.length]);

  const loadSubscriptionsFromUser = () => {
    if (keycloak?.tokenParsed) {
      const roles = keycloak?.tokenParsed?.rolesWithSubscription;
      const ssoSubscription = localStorage.getItem("ssoSubscription");

      let rolesWithSubscriptions: any;

      if (ssoSubscription && ssoSubscription === "beltrame") {
        rolesWithSubscriptions =
          roles &&
          Object.keys(roles)?.filter((key) => key?.includes("uverifyBeltrame"));
      } else {
        rolesWithSubscriptions =
          roles &&
          Object.keys(roles)?.filter((key) => key?.includes("uverify"));
      }

      const rolesWithAttributes: RoleAttributes[] = [];

      rolesWithSubscriptions?.forEach((role: any) => {
        const tempRole = roles[role];
        tempRole.name = tempRole.name[0];
        tempRole.mini = tempRole.mini[0];
        tempRole.subscriptionId = tempRole.subscriptionId[0];
        rolesWithAttributes.push(tempRole);
      });

      rolesWithAttributes.length &&
        setSubscriptionAvailable([...rolesWithAttributes]);
    }
  };

  const setSubscriptionAndStore = (sub: string) => {
    setSubscription(sub);
    localStorage.setItem("subscription", sub);
    setSubscriptionMini(
      subscriptionsAvailable.find((role) => role.subscriptionId === sub)
        ?.mini || ""
    );
  };

  return (
    <SubscriptionContext.Provider
      value={{
        subscription,
        setSubscription: setSubscriptionAndStore,
        subscriptionsAvailable,
        subscriptionMini,
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
};

export function useSubscription(): SubscriptionData {
  const context: any = useContext(SubscriptionContext);

  return context;
}
